import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchWaterbillListThunk = createAsyncThunk(
  "waterbill/fetchList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/waterbill-settings");
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data || [];
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message || "Server error");
    }
  }
);

export const fetchWaterbillByIdThunk = createAsyncThunk(
  "waterbill/fetchById",
  async (wbs_id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/waterbill-settings/${wbs_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data || null;
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message || "Server error");
    }
  }
);

export const saveWaterbillThunk = createAsyncThunk(
  "waterbill/save",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.post("/api/waterbill-settings", payload);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      dispatch(fetchWaterbillListThunk());
      return res.data;
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message || "Server error");
    }
  }
);

export const deleteWaterbillThunk = createAsyncThunk(
  "waterbill/delete",
  async (wbs_id, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.delete(`/api/waterbill-settings/${wbs_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      dispatch(fetchWaterbillListThunk());
      return { ...res.data, wbs_id };
    } catch (e) {
      return rejectWithValue(e?.response?.data?.message || e.message || "Server error");
    }
  }
);

const slice = createSlice({
  name: "waterbillSettings",
  initialState: {
    list: [],
    formData: null,
    loadingList: false,
    loadingOne: false,
    saving: false,
    deleting: false,
    error: null,
    success: null,
  },
  reducers: {
    clearWaterbillMsg(state) {
      state.error = null;
      state.success = null;
    },
    clearWaterbillForm(state) {
      state.formData = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchWaterbillListThunk.pending, (s) => {
      s.loadingList = true;
      s.error = null;
    });
    b.addCase(fetchWaterbillListThunk.fulfilled, (s, a) => {
      s.loadingList = false;
      s.list = a.payload;
    });
    b.addCase(fetchWaterbillListThunk.rejected, (s, a) => {
      s.loadingList = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(fetchWaterbillByIdThunk.pending, (s) => {
      s.loadingOne = true;
      s.error = null;
    });
    b.addCase(fetchWaterbillByIdThunk.fulfilled, (s, a) => {
      s.loadingOne = false;
      s.formData = a.payload;
    });
    b.addCase(fetchWaterbillByIdThunk.rejected, (s, a) => {
      s.loadingOne = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(saveWaterbillThunk.pending, (s) => {
      s.saving = true;
      s.error = null;
      s.success = null;
    });
    b.addCase(saveWaterbillThunk.fulfilled, (s) => {
      s.saving = false;
      s.success = "Saved successfully";
    });
    b.addCase(saveWaterbillThunk.rejected, (s, a) => {
      s.saving = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(deleteWaterbillThunk.pending, (s) => {
      s.deleting = true;
      s.error = null;
      s.success = null;
    });
    b.addCase(deleteWaterbillThunk.fulfilled, (s, a) => {
      s.deleting = false;
      s.success = a.payload?.message || "Deleted successfully";
      s.list = s.list.filter((x) => String(x.wbs_id) !== String(a.payload?.wbs_id));
      if (String(s.formData?.wbs_id || "") === String(a.payload?.wbs_id || "")) {
        s.formData = null;
      }
    });
    b.addCase(deleteWaterbillThunk.rejected, (s, a) => {
      s.deleting = false;
      s.error = a.payload || "Failed";
    });
  },
});

export const { clearWaterbillMsg, clearWaterbillForm } = slice.actions;
export default slice.reducer;